import { useCallback } from 'react';
import { PageNavigation } from '../../document-canvas';
import {
  useActiveSplitPage,
  useScrollToSplitPage,
} from '../../document-split-canvas';
import type { SplitPageIndex } from '../session/pageKeys';

type SplitPageNavigationProps = {
  pageIndex: SplitPageIndex;
  totalPages: number;
};

export const SplitPageNavigation = ({
  pageIndex,
  totalPages,
}: SplitPageNavigationProps) => {
  const activePageId = useActiveSplitPage();
  const scrollToPage = useScrollToSplitPage();

  const currentPage =
    activePageId === null ? 1 : (pageIndex.numberById[activePageId] ?? 1);

  const handleNavigate = useCallback(
    (page: number) => {
      const id = pageIndex.idByNumber[page];
      if (id !== undefined) scrollToPage(id);
    },
    [pageIndex, scrollToPage]
  );

  if (totalPages === 0) return null;

  return (
    <PageNavigation
      currentPage={currentPage}
      totalPages={totalPages}
      onNavigate={handleNavigate}
    />
  );
};
